function copyContent(content: string) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(content);
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = content;

    textArea.style.position = "absolute";
    textArea.style.left = "-999999px";

    document.body.prepend(textArea);
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (error) {
      console.error(error);
    } finally {
      textArea.remove();
    }
  }
}

function formatBigNumber(number?: string) {
  let formatedNumber = number?.split(".")[0] || "-";
  if (formatedNumber.length < 4) {
    return formatedNumber;
  } else if (formatedNumber.length >= 4 && formatedNumber.length < 7) {
    return `${formatedNumber.slice(0, formatedNumber.length - 3)}K${
      formatedNumber?.at(formatedNumber.length - 3) !== "0"
        ? formatedNumber.slice(formatedNumber.length - 3, formatedNumber.length - 2)
        : ""
    }`;
  } else if (formatedNumber.length >= 7 && formatedNumber.length < 10) {
    return `${formatedNumber.slice(0, formatedNumber.length - 6)}M${
      formatedNumber.at(formatedNumber.length - 6) !== "0"
        ? formatedNumber.slice(formatedNumber.length - 6, formatedNumber.length - 5)
        : ""
    }`;
  } else if (formatedNumber.length >= 10 && formatedNumber.length < 13) {
    return `${formatedNumber.slice(0, formatedNumber.length - 9)}B${
      formatedNumber.at(formatedNumber.length - 9) !== "0"
        ? formatedNumber.slice(formatedNumber.length - 9, formatedNumber.length - 8)
        : ""
    }`;
  } else if (formatedNumber.length >= 13) {
    return `${formatedNumber.slice(0, formatedNumber.length - 12)}T${
      formatedNumber.at(formatedNumber.length - 12) !== "0"
        ? formatedNumber.slice(formatedNumber.length - 12, formatedNumber.length - 11)
        : ""
    }`;
  }
}

function removeSigns(inputText: string) {
  const diacriticsMap: Record<string, string> = {
    à: "a",
    á: "a",
    ả: "a",
    ã: "a",
    ạ: "a",
    ă: "a",
    ằ: "a",
    ắ: "a",
    ẳ: "a",
    ẵ: "a",
    ặ: "a",
    â: "a",
    ầ: "a",
    ấ: "a",
    ẩ: "a",
    ẫ: "a",
    ậ: "a",
    è: "e",
    é: "e",
    ẻ: "e",
    ẽ: "e",
    ẹ: "e",
    ê: "e",
    ề: "e",
    ế: "e",
    ể: "e",
    ễ: "e",
    ệ: "e",
    ì: "i",
    í: "i",
    ỉ: "i",
    ĩ: "i",
    ị: "i",
    ò: "o",
    ó: "o",
    ỏ: "o",
    õ: "o",
    ọ: "o",
    ô: "o",
    ồ: "o",
    ố: "o",
    ổ: "o",
    ỗ: "o",
    ộ: "o",
    ơ: "o",
    ờ: "o",
    ớ: "o",
    ở: "o",
    ỡ: "o",
    ợ: "o",
    ù: "u",
    ú: "u",
    ủ: "u",
    ũ: "u",
    ụ: "u",
    ư: "u",
    ừ: "u",
    ứ: "u",
    ử: "u",
    ữ: "u",
    ự: "u",
    ỳ: "y",
    ý: "y",
    ỷ: "y",
    ỹ: "y",
    ỵ: "y",
    đ: "d",
  };

  return inputText.replace(
    /[àáảãạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵđ]/g,
    (match) => diacriticsMap[match] || match,
  );
}

function formatCash(
  str: number | undefined | null,
  seperator: string = ".",
  comma: string = ",",
  unit: string = "VND",
  emptyText: string = "",
) {
  if (str !== undefined && str !== null && typeof str !== "string" && typeof str !== "object" && !Number.isNaN(str)) {
    let splitArr = str.toString().split(".");
    let strWithoutComma = splitArr[0];

    let prefix = strWithoutComma
      .split("")
      .reverse()
      .reduce((total, item, idx, arr) => {
        return idx !== arr.length - 1 && idx % 3 === 2 ? total + item + seperator : total + item;
      }, "")
      .split("")
      .reverse()
      .join("");

    return splitArr.length === 2
      ? prefix.concat(comma, splitArr[1], unit ? ` ${unit}` : "")
      : prefix.concat(unit ? ` ${unit}` : "");
  } else {
    return emptyText;
  }
}

function truncateAddress(address?: string, end = 8, start = -6) {
  return !address ? "-" : address.slice(0, end) + "..." + address.slice(start);
}

export { copyContent, formatBigNumber, formatCash, removeSigns, truncateAddress };
